export const USER_UPDATE_ALL = 'USER_UPDATE_ALL';
export const USER_UPDATE_GROUPS = 'USER_UPDATE_GROUPS';
export const USER_UPDATE_SINGLE = 'USER_UPDATE_SINGLE';
export const USER_GET_SINGLE = 'USER_GET_SINGLE';
export const USER_ADD_TO_SINGLE = 'USER_ADD_TO_SINGLE';
export const USER_GET_GROUPS = 'USER_GET_GROUPS';



// WEBPACK FOOTER //
// ./src/constants/user.js